import { Directionality } from '@angular/cdk/bidi';
import {
  Overlay,
  OverlayContainer,
  OverlayKeyboardDispatcher,
  OverlayOutsideClickDispatcher,
  OverlayPositionBuilder,
  ScrollStrategyOptions,
} from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';
import { DOCUMENT, Location } from '@angular/common';
import {
  ComponentFactoryResolver,
  Directive,
  ElementRef,
  Inject,
  Injectable,
  Injector,
  NgZone,
} from '@angular/core';

@Injectable()
export class ContextTooltipOverlayContainer extends OverlayContainer {
  constructor(
    @Inject(DOCUMENT) document: Document,
    private platform: Platform,
    private containerDirective: ContextTooltipContainerDirective,
  ) {
    super(document, platform);

    this._containerElement = this.containerDirective.container;
  }
}

@Injectable()
export class ContextTooltipOverlay extends Overlay {
  constructor(
    scrollStrategies: ScrollStrategyOptions,
    _overlayContainer: ContextTooltipOverlayContainer,
    _componentFactoryResolver: ComponentFactoryResolver,
    _positionBuilder: OverlayPositionBuilder,
    _keyboardDispatcher: OverlayKeyboardDispatcher,
    _injector: Injector,
    _ngZone: NgZone,
    @Inject(DOCUMENT) _document: Document,
    _directionality: Directionality,
    _location: Location,
    _outsideClickDispatcher: OverlayOutsideClickDispatcher,
  ) {
    super(
      scrollStrategies,
      _overlayContainer,
      _componentFactoryResolver,
      _positionBuilder,
      _keyboardDispatcher,
      _injector,
      _ngZone,
      _document,
      _directionality,
      _location,
      _outsideClickDispatcher,
    );
  }
}

@Directive({
  selector: '[rtWysiwygContextTooltipContainer]',
  providers: [ContextTooltipOverlay, ContextTooltipOverlayContainer],
})
export class ContextTooltipContainerDirective {
  public container: HTMLElement;

  constructor(private elRef: ElementRef) {
    const directiveEl: HTMLElement = this.elRef.nativeElement;
    this.container = document.createElement('div');
    this.container.classList.add('cdk-overlay-container');
    this.container.style.zIndex = '0';
    directiveEl.appendChild(this.container);
  }
}
